import { init, setTag, setUser, captureException } from '@sentry/react';

const SENTRY_DSN =
  'https://0132281c118d46f38956066adf207d56@sentry.thecambusiness.com/4';

class ErrorReporter {
  constructor({ environment }) {
    if (BUILD_ENV !== 'production') {
      return;
    }
    init({
      dsn: SENTRY_DSN,
      environment,
      release: BUILD_SHA,
    });
    setTag('appName', APP_NAME);
  }

  bindStore(store) {
    if (BUILD_ENV !== 'production') {
      return;
    }

    let currentUser = null;

    store.subscribe(() => {
      const {
        auth: { user },
      } = store.getState();

      if (currentUser !== user) {
        currentUser = user;

        if (user) {
          const { id, username } = user;

          setUser({ id, username });
        } else {
          setUser(null);
        }
      }
    });
  }

  captureException(error, extra) {
    if (BUILD_ENV !== 'production') {
      return;
    }

    captureException(error, { extra });
  }
}

const [env, _, maybeStage] = document.location.hostname.split('.').reverse();

const errorReporter = new ErrorReporter({
  environment:
    // eslint-disable-next-line no-nested-ternary
    env === 'dev'
      ? `staging-${maybeStage}`
      : env === 'local'
        ? 'local'
        : 'production',
});

export default errorReporter;
